import { useModelApi, UseModelApiProps, useUpdateMutation } from '@melio/api-client';
import { FundingSourcesApiClient } from '@melio/platform-api-axios-client';

import { FundingSource, PatchFundingSourcesRequest, PostFundingSourcesRequest } from './types';
import { convertVerifyParamsDollarsToCents } from './utils';

type QueryFn = typeof FundingSourcesApiClient.getFundingSourcesFundingSourceId;
type CreateFn = typeof FundingSourcesApiClient.postFundingSources;
type DeleteFn = typeof FundingSourcesApiClient.deleteFundingSourcesFundingSourceId;
type UpdateFn = typeof FundingSourcesApiClient.patchFundingSourcesFundingSourceId;

export type UseFundingSourceProps = UseModelApiProps<QueryFn, FundingSource>;

export const useFundingSource = (props: UseFundingSourceProps = {}) => {
  const query = useModelApi<
    QueryFn,
    UpdateFn,
    DeleteFn,
    CreateFn,
    FundingSource,
    PatchFundingSourcesRequest,
    PostFundingSourcesRequest
  >({
    ...props,
    queryKey: 'FundingSourcesApi',
    queryFn: FundingSourcesApiClient.getFundingSourcesFundingSourceId,
    createFn: FundingSourcesApiClient.postFundingSources,
    deleteFn: FundingSourcesApiClient.deleteFundingSourcesFundingSourceId,
    updateFn: FundingSourcesApiClient.patchFundingSourcesFundingSourceId,
  });

  const verifyMutation = useUpdateMutation(
    FundingSourcesApiClient.postFundingSourcesFundingSourceIdVerify,
    query.queryKey,
    { prepareParams: convertVerifyParamsDollarsToCents }
  );

  const linkMutation = useUpdateMutation(
    FundingSourcesApiClient.postLinkAccountingPlatformPaymentAccount,
    query.queryKey
  );

  return {
    ...query,
    verify: verifyMutation.createCallback(props.id as string),
    linkAccountingPlatformPaymentAccount: linkMutation.createCallback(props.id as string),
  };
};

export type FundingSourceModel = ReturnType<typeof useFundingSource>;
